import { Injectable, inject } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter } from 'rxjs/operators';
import { AlertService } from './alert.service';

@Injectable({ providedIn: 'root' })
export class UpdateService {
  private sw = inject(SwUpdate);
  private alertService = inject(AlertService);
  private started = false;

  public init(): void {
    if (this.started || !this.sw.isEnabled) return;
    this.started = true;

    this.sw.versionUpdates.pipe(filter((e): e is VersionReadyEvent => e.type === 'VERSION_READY')).subscribe(async () => {
      try {
        await this.sw.activateUpdate();
      } catch {}
      this.alertService.showToast('info', 'lABEL_UPDATE_APP');
      setTimeout(() => location.reload(), 4000);
    });

    setInterval((): void => {
      this.sw.checkForUpdate();
    }, 60_000);

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        this.sw.checkForUpdate();
      }
    });
  }
}
